import React from 'react';
import styled from 'styled-components';
import { useBboView } from '@paradigm/features/src/unified-rfqs/ui/bbo-view-context';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import {
  CenterArea,
  PriceCell,
  QuantityCell,
  Row,
  SideArea,
  Space,
  SubTitle,
  Title,
} from './ScreenPriceAndHiddenOrderContainer';

const IvValue = styled.span`
  opacity: 0.3;
  font-size: 0.625rem;
  margin-left: 4px;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 0.75rem;
  }
`;

const ScreenPrice: React.FC<{ 'data-testid'?: string }> = (props) => {
  const {
    bestBidQty,
    bestBidPrice,
    bestAskQty,
    bestAskPrice,
    bestBidIv,
    bestAskIv,
  } = useBboView();

  return (
    <Row data-testid={props['data-testid']}>
      <SideArea>
        <Title>Screen Bid</Title>
        <SubTitle>Unhedged</SubTitle>
      </SideArea>
      <CenterArea>
        <QuantityCell>{bestBidQty.formatted}</QuantityCell>
        <Space />
        <PriceCell>
          {bestBidPrice.formatted}
          {bestBidIv.formatted !== '' && (
            <IvValue data-testid="best-bid-iv">{bestBidIv.formatted}</IvValue>
          )}
        </PriceCell>
        <Space />
        <PriceCell>
          {bestAskPrice.formatted}
          {bestAskIv.formatted !== '' && (
            <IvValue data-testid="best-ask-iv">{bestAskIv.formatted}</IvValue>
          )}
        </PriceCell>
        <QuantityCell>{bestAskQty.formatted}</QuantityCell>
        <Space />
      </CenterArea>
      <SideArea>
        <Title>Screen Ask</Title>
        <SubTitle>Unhedged</SubTitle>
      </SideArea>
    </Row>
  );
};

export default ScreenPrice;
